import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import DataRich from "../assest/images/02-Enriched-Databases-Data-Validation.svg";
import LeadGeneration from "../assest/images/01-B2B-Lead-Generation-Data-Research-Solutions.svg";
import DataRefresh from "../assest/images/Data-Refresh-Data-Append-1.png";
const Service = () => {
  return (
    <>
      <section>
        <Container>
          <Row>
            <Col xs="12" className="py-3">
              <div className="servicebanner pad_50">
                <div className="monts text-white service_text">Services</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pad_90">
        <Container>
          <div className="navbar_bg vision_point">
            <Container>
              <Row className="justify-content-center">
                <Col lg="5" xs="12" className="py-3">
                  <div>
                    <img
                      src={DataRich}
                      alt="Service Icon"
                      width={80}
                      height={80}
                    />
                  </div>
                  <div className="monts">
                    <h4>Enriched Databases & Data Validation</h4>
                  </div>
                  <div className="monts-regular fs-14">
                    <p>
                      Today’s marketing success relies on precision. Our data segmentation solutions help you group, filter, and target your ideal audience based on behavioral, demographic, firmographic, and engagement attributes. By aligning campaigns with highly relevant segments, you reduce waste and increase conversion rates with measurable efficiency.
                    </p>
                  </div>
                </Col>
                <Col lg="5" xs="12" className="py-3">
                  <div>
                    <img
                      src={LeadGeneration}
                      alt="Service Icon"
                      width={80}
                      height={80}
                    />
                  </div>
                  <div className="monts">
                    <h4>B2B Lead Generation & Data Research Solutions</h4>
                  </div>
                  <div className="monts-regular fs-14">
                    <p>
                      Gain an edge in prospecting by identifying buyers who are actively looking for your solutions. Our intent-based data research leverages behavioral triggers, web analytics, and predictive scoring to prioritize high-intent accounts. This lets your sales team focus on warm leads and shorten sales cycles dramatically.


                    </p>
                  </div>
                </Col>
                <Col lg="5" xs="12" className="py-3">
                  <div>
                    <img
                      src={DataRefresh}
                      alt="Service Icon"
                      width={80}
                      height={80}
                    />
                  </div>
                  <div className="monts">
                    <h4>Data Refresh & Data Append</h4>
                  </div>
                  <div className="monts-regular fs-14">
                    <p>
                      Our ABM-ready datasets are built for personalized outreach. From C-level contacts to buying committees, we provide verified data that supports account-specific targeting strategies. You’ll get access to detailed account insights that drive more effective 1:1 marketing engagement and ROI.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Service;
